import { render, staticRenderFns } from "./ManualBankingWarning.vue?vue&type=template&id=7983b085"
import script from "./ManualBankingWarning.vue?vue&type=script&lang=js"
export * from "./ManualBankingWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports